/**
 * StatusBadge — a link-status / return-status chip. Always combines COLOR + GLYPH + TEXT (never color
 * alone; daltonisme + médico-légal). Thin wrapper over the UI Badge that maps a status to its tone +
 * mandated glyph + i18n label.
 */
import { Badge } from "@/ui";
import { useT } from "@/app";
import type { LienStatut } from "../types";
import { lienVisual, retourVisual } from "../lib";

export function LienBadge({ statut }: { statut: LienStatut | null }) {
  const { t } = useT();
  const v = lienVisual(statut);
  return (
    <Badge tone={v.tone} glyph={v.glyph}>
      {t(v.labelKey)}
    </Badge>
  );
}

export function RetourBadge({ statut }: { statut: string }) {
  const { t } = useT();
  const v = retourVisual(statut);
  return (
    <Badge tone={v.tone} glyph={v.glyph}>
      {t(v.labelKey)}
    </Badge>
  );
}
